export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0A0A0A" stroke="rgba(204,255,0,0.4)" strokeWidth="2" />
    <path d="M11 46V19l10.5 12L32 19v27" stroke="#CCFF00" strokeWidth="5" strokeLinecap="square" strokeLinejoin="miter" />
    <path d="M33 46V19l10.5 12L54 19v27" stroke="#CCFF00" strokeWidth="5" strokeLinecap="square" strokeLinejoin="miter" />
  </svg>
);

export default function Logo() {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark />
      <span className="font-display text-2xl font-black uppercase leading-none tracking-tight text-white">
        MM<span className="text-volt"> Store</span>
      </span>
    </span>
  );
}
